import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11.71 15.29l2.59-2.59c.39-.39.39-1.02 0-1.41L11.71 8.7c-.63-.62-1.71-.18-1.71.71v5.17c0 .9 1.08 1.34 1.71.71z"
}), 'ArrowRightRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ArrowRightRounded.js
// module id = 2120
// module chunks = 2